import { keepPreviousData } from "@tanstack/react-query"

import { api } from "~/utils/api"

export function useAllocationSkuExtraDataMap(skuIds: string[], fields: string[]) {
  return api.allocation.getAllocationSkuExtraDataMap.useQuery(
    { skuIds, fields },
    { enabled: skuIds.length > 0 && fields.length > 0, placeholderData: keepPreviousData },
  )
}
